function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHotelRyokanFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 27H1v-1.774h30V27z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.311 15.468c0-.49.398-.887.889-.887h25.6c.49 0 .889.397.889.887v10.645c0 .49-.398.887-.89.887H3.2a.888.888 0 01-.888-.887V15.468zm1.778.887v8.87H27.91v-8.87H4.089zM5.511 14.58v-2.483H7.29v2.484H5.51zM24.711 14.58v-2.483h1.778v2.484H24.71z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.711 25.226v-8.87h1.778v8.87H8.71zM12.978 25.226V18.94h1.777v6.285h-1.777zM17.244 25.226V18.94h1.778v6.285h-1.777zM21.511 25.226v-8.871h1.778v8.87H21.51zM15.391 5.168a.89.89 0 011.034-.006l7.554 5.323a.886.886 0 01-.512 1.612H8.533a.886.886 0 01-.52-1.606l7.378-5.323zm.527 1.81l-4.637 3.345h9.385l-4.748-3.346z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.711 15.468c0-.49.398-.887.889-.887h12.8c.49 0 .889.397.889.887v4.258c0 .49-.398.887-.889.887H9.6a.888.888 0 01-.889-.887v-4.258zm1.778.887v2.484H21.51v-2.484H10.489zM7.687 11.485a.887.887 0 01.33-.994l.23-.168h-3.35L6.62 7.839h5.066l2.462-1.775h-8a.875.875 0 00-.728.382l-2.952 4.258a.87.87 0 00-.053.914c.16.293.453.479.791.479h5.325a.889.889 0 01-.845-.612zM29.527 10.704l-2.95-4.258a.887.887 0 00-.73-.382h-8.142l2.516 1.775h5.155l1.724 2.484h-3.35l.23.16c.32.221.454.62.338.993a.885.885 0 01-.844.62h5.333a.907.907 0 00.791-.478.869.869 0 00-.053-.914h-.018z",
    fill: props.color
  }));
}

export default SvgIconHotelRyokanFilled;